var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-with-name"},[_c('ImageLoader',{attrs:{"src":_vm.src,"size":_vm.size,"border-type":"circle"}},[_vm._t("default",function(){return [_c('a-icon',{attrs:{"type":"file-image"}})]})],2),_vm._v(" "),_c('span',{class:_vm.cNameCssClass},[_vm._v(_vm._s(_vm.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }